module.exports = __webpack_public_path__ + "img/flicky-christmas-1.9a2c8793.webp";